export default __webpack_public_path__ + "static/media/textsearch_locked.4aa2c6a8.svg";